<template>
  <div tabindex="-1" class="modal-content">
    <header class="modal-header bg-danger text-white">
      <h5 class="modal-title">
        Error
      </h5>
    </header>
    <div class="modal-body">
      <h6 v-html-sanitize="messageTitle"></h6>
    </div>
    <footer class="modal-footer">
      <button @click="handleConfirm" type="button" class="btn btn-danger">
        Close
      </button>
    </footer>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // Include mixin

export default {
  name: "DialogErrorModal",
  mixins: [DialogMixin],
  methods: {
    handleConfirm() {
      this.proceed(); // included in DialogMixin
    }
  },
  components: {}
};
</script>

<style scoped="">
.modal-content {
  margin: -15px;
  width: auto;
}
</style>
